import React, { useState, useEffect } from "react";
import { FaUser } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { BiLogOutCircle } from "react-icons/bi";
import Logo from "../../../../assets/LOGO HRIS 6.png";
import Reset_Pw from "../../employee/dashbaord/reset_password";
import Cookies from "js-cookie";

const Navbar = () => {
  const [user, setUser] = useState(Cookies.get("employee_calling_name") || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Retrieve user data from localStorage if not using cookies
    const userData = localStorage.getItem("user");
    if (userData) {
      const parsedData = JSON.parse(userData);
      const fullName = parsedData.employee_fullname || "";
      setUser(fullName); // Set fullName or use the appropriate value
    }
  }, []);

  const handleLogout = () => {
    // Clear local storage and cookies
    localStorage.clear();
    Cookies.remove("employee_calling_name");
    Cookies.remove("token");
    Cookies.remove("employee_no");
    // Clear cache and redirect to login
    window.location.href = "/login?cache_buster=" + new Date().getTime();
  };

  return (
    <div>
      <div className="flex justify-center mt-[69px] font-sans">
        <div className="shadow-lg bg-white w-[1600px] h-[83px] rounded-[24px]">
          <div className="flex justify-between items-center mt-3 px-4">
            {/* logo */}
            <div className="flex items-center gap-4">
              <div>
                <img src={Logo} alt="logo" className="h-[70px] w-[70px]" />
              </div>
              <div>
                <p className="text-[24px] font-bold text-gray-500">
                  Sri Lanka Ayurvedic Drugs Corporation
                </p>
              </div>
            </div>

            {/* user */}
            <div className="flex items-center gap-5 relative">
              <FaUser className="w-[20px] h-[20px]" />
              <p>{user}</p>

              <div className="ml-4 relative">
                <IoIosArrowDown
                  className="w-[24px] h-[21px] cursor-pointer"
                  onClick={() => setShowDropdown(!showDropdown)}
                />
                {showDropdown && (
                  <div className="absolute bg-white rounded-[30px] shadow-lg mt-1 z-10">
                    <p
                      className="py-2 cursor-pointer px-4 hover:bg-[#6A2E92] hover:text-white hover:rounded-t-2xl"
                      onClick={() => setShowPopup(true)}
                    >
                      Reset Password
                    </p>
                  </div>
                )}
              </div>

              <BiLogOutCircle
                className="w-[24px] h-[21px] cursor-pointer ml-4"
                onClick={handleLogout}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Popup for Reset Password */}
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <Reset_Pw onClose={() => setShowPopup(false)} />
        </div>
      )}
    </div>
  );
};

export default Navbar;
